<template>
  <div>
    <el-table height="900" :data="auditList">
      <el-table-column label="时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="userId" label="账号ID"></el-table-column>
      <el-table-column prop="realName" label="真实姓名"></el-table-column>
      <el-table-column prop="cardNo" label="证件号"></el-table-column>
      <el-table-column prop="idType" label="证件类型">
        <template slot-scope="scope">
          <!-- {{scope.row.idType === 1 ? '护照' : '身份证'}} -->
          <span v-if="scope.row.idType == 0">身份证</span>
          <span v-if="scope.row.idType == 1">护照</span>
          <span v-if="scope.row.idType == 2">驾照</span>
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="" label="失败原因" v-if="types == null">
        <template slot-scope="scope">
          <span v-if="scope.row.backReason == 201">官方数据库中姓名和身份证不一致。可能是用户的信息有误或用户的信息为假信息，建议用户确认后重新操作</span>
          <span v-if="scope.row.backReason == 202">官方数据库查询不到身份信息。建议预留人工审核入口，进行人工审核</span>
          <span v-if="scope.row.backReason == 204">活体人脸和证脸比对不一致。可能人证不符或活体照片质量较低</span>
          <span v-if="scope.row.backReason == 205">活体检测存在风险</span>
          <span v-if="scope.row.backReason == 206">卸载掉设备上可能安装的各种多开、分身、虚拟环境等软件或插件，恢复设备系统初始安全环境后重试</span>
          <span v-if="scope.row.backReason == 207">官方数据库中人脸核验失败。可能不是同一人或活体照片质量较低</span>
          <span v-if="scope.row.backReason == 209">权威比对源异常</span>
          <span v-if="scope.row.backReason == 212">证件防伪检测存在风险。可能存在翻拍、篡改、复印等高风险操作</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="
              scope.row.status === 0 && $hasPerm('tenant:audit_kyc:tab_0_audit')
            "
            @click="approveAudit(scope.row.id)"
            >审核</el-button
          >
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.status !== 0 && scope.row.status != 4"
            @click="approveAudit(scope.row.id)"
            >查看</el-button
          >
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.status == 3 && types == null"
            @click="del(scope.row.id)"
            >删除</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-if="
              scope.row.status == -1 &&
              $hasPerm('tenant:audit_kyc:tab_-1_remove_blacklist')
            "
            @click="cancelBlack(scope.row.id)"
            >移除黑名单</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-if="
              scope.row.status === 0 &&
              $hasPerm('tenant:audit_kyc:tab_0_blacklist')
            "
            @click="blackList(scope.row.id)"
            >拉入黑名单</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-if="
              scope.row.status === 1 &&
              $hasPerm('tenant:audit_kyc:tab_1_remove_realname')
            "
            @click="toFail(scope.row.userId)"
            >移除实名</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></Pagination>
    <audit-detail
      :value="auditId"
      :type="types"
      @onUpdate="onUpdate"
    ></audit-detail>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import AuditDetail from "../detail";
import api from "../../api";
export default {
  name: "KYCAudit",
  props: ["types"],
  data() {
    return {
      auditId: null,
    };
  },
  components: {
    Pagination,
    AuditDetail,
  },
  methods: {
    ...mapMutations("kycAudit", ["toggleDetailDialogVisible", "setPagination"]),
    ...mapActions("kycAudit", ["list", "approve", "RollBack"]),
    approveAudit(id) {
      this.auditId = id;
      this.toggleDetailDialogVisible(true);
    },
    toFail(userId) {
      this.$prompt("请输入审核不通过原因", "提示", {}).then(({ value }) => {
        this.RollBack({
          backReason: value,
          userId: userId,
        }).then(() => {
          this.$message({
            type: "success",
            message: "操作成功！",
          });
          this.$emit("refresh");
        });
      });
    },
    pageChanged(pagination) {
      this.setPagination(pagination);
      this.$emit("refresh", pagination);
    },
    onUpdate() {
      this.$emit("refresh");
    },
    blackList(id) {
      this.$confirm("确认将此用户拉入黑名单吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.approve({ id, status: "-1" }).then(() => {
          this.$message({
            type: "success",
            message: "操作成功！",
          });
          this.$emit("refresh");
        });
      });
    },
    cancelBlack(id) {
      this.$confirm("确认将此用户移除黑名单吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.approve({ id, status: "0" }).then(() => {
          this.$message({
            type: "success",
            message: "操作成功！",
          });
          this.$emit("refresh");
        });
      });
    },
    del(id) {
      api.delApi({ id }).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功！");
          this.$emit("refresh");
        }
      });
    },
  },
  computed: {
    ...mapGetters("kycAudit", ["auditList"]),
    ...mapState("kycAudit", ["pagination", "totalCount", "activeTab"]),
  },
};
</script>

<style lang="less" scoped></style>
